<template>
  <div>
    <b-row>
      <b-col
        cols="12"
        md="6"
      >

        <input-field
          name="play_ready-playReadyServerUrl"
          label="Play ready server url *"
          label-position="top"
        >
          <div>
            {{ settings.playReadyServerUrl }}
          </div>

        </input-field>
      </b-col>
      <b-col
        cols="12"
        md="6"
      >

        <input-field
          name="play_ready-clientCertFile"
          label="Client Cert File *"
          label-position="top"
        >
          <div>
            {{ settings.clientCertFile }}
          </div>
        </input-field>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        cols="12"
        md="6"
      >

        <input-field
          name="play_ready-clientCertPrivateKeyFile"
          label="Client Cert Private Key File *"
          label-position="top"
        >
          <div>
            {{ settings.clientCertPrivateKeyFile }}
          </div>
        </input-field>

      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <input-field
          name="play_ready-clientCertPrivateKeyPassword"
          label="Client Cert Private Key Password *"
          label-position="top"
        >
          <span class="position-relative">
            {{ settings.clientCertPrivateKeyPassword }}

            <span
              v-if="!showPassword "
              class="position-absolute keyPlaceholder text-nowrap overflow-hidden"
            >
              {{ dots }}
            </span>
          </span>
          <b-button
            variant="bg-white"
            class="toggleShowKey ml-1 text-xsm"
            @click="showPassword = !showPassword"
          >
            {{ showPassword ? 'Hide' : 'Show' }}
          </b-button>
        </input-field>
      </b-col>
    </b-row>
  </div>
</template>
<script>

import InputField from '@/components/form/InputField.vue'

export default {
  name: 'PlayReady',
  components: {
    InputField,
  },
  props: {
    settings: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showPassword: false,
      dots: '•••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••',
    }
  },
}
</script>

<style>
 button.btn.toggleShowKey{
    height:26px !important;
    padding:0 9px;
  }
  .keyPlaceholder{
    right:0;
    top:0;
    bottom:0;
    right:0;
    background-color:white;
    width:100%;
  }
</style>
